var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.07c0-2.425 2.683-3.89 4.724-2.578l10.868 6.987c1.877 1.207 1.877 3.95 0 5.158L9.724 23.623C7.684 24.935 5 23.47 5 21.044V7.071zm3.618-.859a1.022 1.022 0 00-1.574.86v13.973c0 .809.894 1.297 1.574.86l10.869-6.987a1.022 1.022 0 000-1.719L8.618 6.211z"
  })));
}
export default SvgPlay;